<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="1200">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            Listagem de Formações
          </div>
        </v-toolbar>
        <div class="container dialog mt-4">
          <h3>
            Listagem de Escolas com Formações
          </h3>
          <v-row class="justify-center">
            <v-data-table
                class="mt-5"
                :headers="headers"
                :items="lists.formacoes"
                :items-per-page="10"
                :footer-props="$footerProps"
                show-expand
                style="min-width: 900px;"
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td class="my-expand-table" :colspan="headers.length" v-if="item.formacoes?.length > 0">
                  <v-simple-table dense>
                    <thead>
                        <tr>
                          <th scope="col">Nome da Formação</th>
                          <th scope="col">Status</th>
                          <th scope="col">Responsável</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(formacao, i) in item.formacoes" :key="i + formacao.id">
                          <td>{{ formacao.nome }}</td>
                          <td>{{ formacao.status }}</td>
                          <td>{{ formacao.responsavel }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                </td>
              </template>
            </v-data-table>
          </v-row>
        </div>
        <v-row class="pl-8 pr-8 mt-n4">
          <v-col cols="12">
            <p>Quantidade de Formações: {{
              lists.formacoes?.reduce((total, item) => total + (item.totalFormacoes || 0), 0)
              }}
            </p>   
            <p class="formacao-info">Quantidade de Escolas: {{ lists.formacoes?.length || 0 }}</p>
          </v-col>
        </v-row>
        <v-row  class="d-flex justify-center mt-4 mb-4" style="gap:2rem;">
          <v-btn outlined color="primary" @click="$emit('onClose')">Voltar</v-btn>
          <v-btn color="primary" class="mr-3" @click="baixarRelatorioPdf" >Exportar</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import {Dashboard} from "commons/classes/dashboard";
import DashboardFormacaoService from "services/dashboard-formacao.service";

export default {
  props: new DialogProps(Dashboard),
  mixins: [DashboardFormacaoService],
  data: () => ({
    lists: {
      formacoes: [],
    },
    headers: [
      { text: "Escola", align: "center", value: "escola" },
      { text: "GRE", align: "center", value: "gre" },
      { text: "Formações", align: "center", value: "data-table-expand" },
      { text: "Quantidade de Formações", align: "center", value: "totalFormacoes" },
    ],
  }),
  methods: {
    getFormacoes() {
      this.$buscarDashboardEscolasComFormacao({ params: {GreCodigo: this.content.id, OrigemId: this.content?.origemId}}).then(
          ({ data }) => this.lists.formacoes= data.lista
      )
    },
    async baixarRelatorioPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$buscarDashboardListaEscolasComFormacoesPdf(this.$montarParamsFilters(
            {GreCodigo: this.content.id, OrigemId: this.content?.origemId}));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.ListagemEscolasComFormacao.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
        this.hidePageLoading();
      }
    },
  },
  mounted() {
    this.getFormacoes();
  },
}
</script>

<style lang="scss" scoped>
  .my-expand-table {
    padding: 0!important;
    .v-data-table {
        border-radius: 0!important;
    }

    th {
        color: #000000 !important;
    }
  }
  .total-participantes {
    font-size: 0.8rem;
    margin-top: -2.7rem;
    margin-left: -20rem;
  }
</style>